import React from "react";

export default class DataLayer extends React.Component {
  static get data() {
    return window.lp.analytics.dataLayer[0];
  }

  static propTypes = {
    data: React.PropTypes.objectOf(Object),
  };

  componentDidMount() {
    Object.assign(DataLayer.data, this.props.data);
  }

  componentWillReceiveProps(nextProps) {
    Object.assign(DataLayer.data, nextProps.data);
  }

  render() {
    return (
      <div className="DataLayer" />
    );
  }
}



// WEBPACK FOOTER //
// ./assets/shared/components/dataLayer.jsx